
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("page-menu");
  const iconMenu = document.querySelector(".icon-menu");
  const menuToggle = document.querySelector('[data-modal-nav-toggle]'); 
  menuToggle.setAttribute("aria-expanded", "false");
  function updateAria() {
    if (menu.classList.contains("reveal")) {
      iconMenu.setAttribute("aria-label", "Close menu");
      menu.setAttribute("aria-hidden", "false");
      menuToggle.setAttribute("aria-expanded", "true"); 

    } else if (menu.classList.contains("unreveal")) {
      iconMenu.setAttribute("aria-label", "Open menu");
      menu.setAttribute("aria-hidden", "true");
      menuToggle.setAttribute("aria-expanded", "false"); 
      menuToggle.focus();                               
    }
  }
  updateAria();
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        updateAria();
      }
    });
  });

  observer.observe(menu, { attributes: true });
});


document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector('[data-modal-nav-toggle]');
  const menu = document.getElementById("page-menu-dialog");
  const mainContent = document.querySelector("#MainContent");
  if(menuBtn && menu){
    menuBtn.addEventListener("click", function(){
      if(mainContent){
        mainContent.setAttribute("aria-hidden","true");
      }
      setTimeout(()=>{
        menu.focus();
      },100);
    });
  }
  const closeLinks = menu.querySelectorAll("a");
  closeLinks.forEach(link=>{
    link.addEventListener("click",function(){
      if(mainContent){
        mainContent.removeAttribute("aria-hidden");
      }
    })
  });
});